<template>
    <standard>
        <router-view></router-view>
    </standard>
</template>

<script>
    import Standard from './components/layout/Standard'
    export default {
        name: 'app',
        components: {
            Standard
        }
    }
</script>

<style lang='scss'>
    @import '../node_modules/bootstrap/scss/bootstrap';
    @import url('https://fonts.googleapis.com/css?family=Gothic+A1');

    $credicysRed:#d93752;

    $credicysRed:#d93752;

    .btn-primary {
        @include button-variant($credicysRed, darken($credicysRed, 7.5%), darken($credicysRed, 10%), lighten($credicysRed,5%), lighten($credicysRed, 10%), darken($credicysRed,30%));
    }

    .btn-outline-primary {
        @include button-outline-variant($credicysRed, #222222, lighten($credicysRed,5%), $credicysRed);
    }

    body {
        font-family: 'Gothic A1', sans-serif;
    }

    .red {
        color: $credicysRed;
    }

    .centered {
        text-align: center;
        margin: auto;
    }

    .mb1 {
        margin-bottom: 5em;
    }

    .pb1 {
        padding-bottom: 5em;
    }
    .link-unstyled {
        &,
        &:visited,
        &:hover,
        &:active,
        &:focus,
        &:active:hover {
            font-style: inherit;
            color: inherit;
            background-color: transparent;
            font-size: inherit;
            text-decoration: none;
            font-variant: inherit;
            font-weight: inherit;
            line-height: inherit;
            font-family: inherit;
            border-radius: inherit;
            border: inherit;
            outline: inherit;
            box-shadow: inherit;
            padding: inherit;
            vertical-align: inherit;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue